// src/pages/AppointmentPage/AnnualTaxReturnReviewPage.tsx

import React, { useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import api from "../../api/client";
import styles from "./AnnualTaxReturnReviewPage.module.scss";
import { InlineWidget } from "react-calendly";

const AnnualTaxReturnReviewPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [promoCode, setPromoCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showCalendly, setShowCalendly] = useState(false);
  const [userInfo, setUserInfo] = useState<{
    fullName?: string;
    email?: string;
  } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage("");
    try {
      const res = await api.post("/checkPromo", {
        promo_code: promoCode,
      });
      if (res.data.valid) {
        setUserInfo(res.data.userInfo);
        setShowCalendly(true);
      } else {
        setErrorMessage(t("appointment.invalidPromoCode"));
      }
    } catch (err) {
      console.error(err);
      setErrorMessage(t("appointment.submitFail"));
    }
  };

  const handleBack = () => {
    // 返回appointment主页面
    navigate("/appointment");
  };

  return (
    <div className={styles.reviewPage}>
      <div className={styles.reviewContainer}>
        {!showCalendly ? (
          <>
            <h1>{t("appointment.annualTaxReturnReview")}</h1>
            <form onSubmit={handleSubmit} className={styles.reviewForm}>
              {/* <div className={styles.formLabel}>
                <label>{t("appointment.email")}</label>
                <input
                  type="email"
                  className={styles.inputField}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div> */}
              <div className={styles.formLabel}>
                <div className={styles.infoHint}>
                  <div className={styles.infoIcon}>ℹ️</div>
                  <div className={styles.infoContent}>
                    <strong>* </strong>
                    <Trans
                      i18nKey="appointment.promoCodeInfo"
                      components={{
                        taxdome: (
                          <a
                            href="https://unlimitedadvisory.taxdome.com/signup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            TaxDome
                          </a>
                        ),
                      }}
                    />
                  </div>
                </div>
                <hr className={styles.divider} />
                <strong>
                  <label>{t("appointment.promoCode")}</label>
                </strong>
                <input
                  type="text"
                  className={styles.inputField}
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  required
                />
              </div>
              {errorMessage && (
                <p className={styles.errorMessage}>{errorMessage}</p>
              )}
              <div className={styles.buttons}>
                <button type="button" onClick={handleBack}>
                  {t("general.back")}
                </button>
                <button type="submit">{t("general.submit")}</button>
              </div>
            </form>
          </>
        ) : (
          <>
            <h1>{t("appointment.selectTimeReview")}</h1>
            <p className="referral-text">
              {t("appointment.yourPromoCode")}
              {": "}
              <strong style={{ color: "red" }}>{promoCode}</strong>
            </p>
            <hr className={styles.divider} />
            {/* Calendly内嵌组件：请将下面的url替换为您自己的Calendly日程链接 */}
            <div style={{ marginTop: "10px" }}>
              <InlineWidget
                url="https://calendly.com/ruifan-wu/annual-tax-return-review"
                styles={{ height: "800px" }}
                prefill={{
                  name: userInfo?.fullName,
                  email: userInfo?.email,
                  customAnswers: {
                    a1: promoCode,
                  },
                }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AnnualTaxReturnReviewPage;
